import React from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'
import { routes } from 'app/routes'
import { QuotationDetail } from './QuotationDetail'
import styled from 'styled-components'
import { CompleteRegistration } from 'app/components/shared/CompleteRegistration'
import { Container } from 'app/components/ui/Container'
import { QuotationList } from './QuotationList'

export const Dashboard: React.FC = () => {
  const { push } = useHistory()

  return (
    <DashboardWrapper>
      <Container>
        <CompleteRegistration
          onReUploadDocumentRequest={() =>
            push(routes.profile.makeUrl(), {
              showHolderDocumentUploadModal: true,
            })
          }
        ></CompleteRegistration>
      </Container>
      <Switch>
        <Route exact path={routes.dashboard.path}>
          <QuotationList />
        </Route>
        <Route exact path={routes.quotation.path}>
          <QuotationDetail />
        </Route>
      </Switch>
    </DashboardWrapper>
  )
}

const DashboardWrapper = styled.div``
